var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBroom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17017 5.52902L6.2395 7.31142L4.90271 5.11771C4.41426 4.3122 4.67134 3.24962 5.47684 2.76118C6.28235 2.27273 7.34493 2.52979 7.83337 3.3353L9.17017 5.52902Z",
    stroke: "white",
    strokeWidth: 1.28538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8411 8.51966L8.13326 10.165C6.55652 11.1247 6.07664 13.0614 6.8393 14.6038L8.59599 18.1858C9.16156 19.3426 10.5326 19.7453 11.6295 19.0684L17.1395 15.7178C18.2449 15.0494 18.5106 13.6526 17.7479 12.6158L15.3742 9.41089C14.3459 8.02268 12.4179 7.55991 10.8411 8.51966Z",
    stroke: "white",
    strokeWidth: 1.28538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92995 5.03885L5.53857 7.71296L7.32131 10.6405L11.7127 7.96643L9.92995 5.03885Z",
    stroke: "white",
    strokeWidth: 1.28538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9749 15.0751L14.3888 17.3974",
    stroke: "white",
    strokeWidth: 1.28538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7811 16.4119L12.195 18.7342",
    stroke: "white",
    strokeWidth: 1.28538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1686 13.7383L16.5825 16.0606",
    stroke: "white",
    strokeWidth: 1.28538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroom);
export default __webpack_public_path__ + "static/media/broom.ebdcecf16a8887311efa2f32c47c2733.svg";
export { ForwardRef as ReactComponent };